export * from './highlight-new-content';
